import React from "react";
import TopBanner from "../components/banner/topBanner";
import { Banners } from "../components/data";
import TeamBlock from "../components/blocks/teamBlock";


export default function Team() {
    return(
        <div className="Team">
            <TopBanner title={Banners[7].title}/>
            <TeamBlock />
        </div>
    )
}